/**
 * Detect fn
 */
export default () => 'MIN_SAFE_INTEGER' in Number;
